<template>
  <div class="wrap-login-page d-flex justify-content-center align-items-center">
    <div class="container">
      <Card>
        <div class="row g-0">
          <div class="col-lg-6">
            <div class="p-lg-5 p-4">
              <!-- <div>
                <h5>Welcome to Mansfield !</h5>
                <p class="text-muted">Sign in to continue to Mansfield CRM</p>
              </div> -->

              <div class="mt-4 pt-3">
                <div v-if="!selectedUserType.code">
                  <p><b> Select User Type </b></p>

                  <v-select
                    class="mb-3"
                    v-model="selectedUserType"
                    :clearable="false"
                    :options="[
                      { label: 'Customers', code: 'Customers' },
                      { label: 'Team MPG', code: 'MPG' },
                      { label: 'Brokers', code: 'Brokers' },
                    ]"
                  ></v-select>
                </div>
                <div v-else class='pb-3'>
                  User Type: {{ selectedUserType.label }} <button class='btn btn-warning' @click="selectedUserType = {'code': '', label: ''}">Change</button>
                </div>

                <a
                        class="btn btn-primary"
                        :href="redirectUrl"
                        v-if="selectedUserType.code === 'MPG'"
                        >Azure Active Directory</a
                      >

                <form
                  v-if="selectedUserType.code !== '' && selectedUserType.code != 'MPG' "
                  @submit.prevent="onSubmit"
                  novalidate
                  enctype="multipart/form-data"
                  :class="
                    submitted
                      ? 'needs-validation was-validated'
                      : 'needs-validation'
                  "
                >
                  <input
                    type="hidden"
                    name="csrfmiddlewaretoken"
                    value="FV755exXJdpyPdGWN4ZBZzbWn835ke7837mXz1kUwni7pziTzt3YN1PRkrMfTxle"
                  />

                  <!-- <div class="alert alert-success mb-4" role="alert">
                    <strong>You have signed out.</strong>
                  </div> -->

                  <ul v-if="error" class="errorlist nonfield">
                    <li>{{ error }}</li>
                  </ul>
                  <div class="form-group">
                    <input
                      type="text"
                      name="login"
                      placeholder="Mansfield Email"
                      autocomplete="username"
                      maxlength="150"
                      class="textinput textInput form-control"
                      id="id_login"
                      v-model.trim="$v.username.$model"
                      required
                    />
                    <div
                      v-if="submitted && !$v.username.required"
                      class="invalid-tooltip"
                    >
                      Username is required
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      name="password"
                      placeholder="Mansfield Password"
                      autocomplete="current-password"
                      class="textinput textInput form-control"
                      v-model.trim="$v.password.$model"
                      required
                      id="id_password"
                    />
                    <div
                      v-if="submitted && !$v.password.required"
                      class="invalid-tooltip"
                    >
                      Password is required
                    </div>
                  </div>

                  <!-- <p class="">
                    <label class="form-check-label pr-4" for="defaultCheck1">
                      Remember Me:
                    </label>
                    <input
                      v-model="isRemember"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                    />
                  </p> -->

                  <div class="d-flex justify-content-end">
                    <div class="text-right">
                      <button
                        class="btn btn-primary w-md waves-effect waves-light"
                        id="user-login"
                        type="submit"
                      >
                        Log In
                      </button>

                      <button
                        v-if="selectedUserType.code !== 'MPG'"
                        class="
                          btn btn-primary
                          w-md
                          waves-effect waves-light
                          ml-2
                        "
                        id="user-login"
                        type="button"
                      >
                        Create User
                      </button>
                    </div>
                  </div>

                  <!-- <div class="mt-4">
                    <a href="/account/password/reset/" class="text-muted"
                      ><i class="mdi mdi-lock me-1"></i> Forgot your
                      password?</a
                    >
                  </div> -->
                </form>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="wrap-logo w-100 h-100">
              <img
                class="img-fluid w-100"
                src="https://c.tenor.com/Z8IxnZrmkWAAAAAC/blue-flame-flame.gif"
              />
              <img
                src="https://djangompg.blob.core.windows.net/media/images/mansfield-energy-logo.png"
                class="main-logo"
                alt=""
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import { router } from '../router'
import { authenticationService } from '../services/authentication.service'
import { utilService } from '../services/util.service'

import Card from '@/components/Card'
export default {
  name: 'Login',
  components: { Card },
  computed: {
    redirectUrl () {
      return `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/login/azuread-custom/`
    }
  },
  data () {
    return {
      username: '',
      password: '',
      submitted: false,
      loading: false,
      isRemember: true,
      returnUrl: '/',
      error: '',
      selectedUserType: { label: '', code: '' }
    }
  },
  validations: {
    username: { required },
    password: { required }
  },
  async created () {
    console.log(this.$route)
    if (this.$route.query && this.$route.query.code) {
      const code = this.$route.query && this.$route.query.code
      const url = `${
        process.env.VUE_APP_ACTIVE_DOMAIN_URL
      }/rest/complete/azuread-custom/?code=${code}&requestUri=${this.getUri()}`
      let response
      try {
        response = await axios.get(url)
      } catch (e) {
        console.log('invalid code')
        return
      }
      authenticationService.activeDirectoryLogin(response.data)
    }
    // redirect to home if already logged in
    if (authenticationService.currentUserValue) {
      return router.push('/')
    }

    // get return url from route parameters or default to '/'
    this.returnUrl = this.$route.query.returnUrl || '/'
  },
  methods: {
    getUri () {
      const questionMarkPos = document.location.href.indexOf('?')
      const uri =
        questionMarkPos > -1
          ? document.location.href.substring(0, questionMarkPos)
          : document.location.href
      return uri
    },
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      //
      this.loading = true
      authenticationService
        .login(this.username, this.password, this.isRemember)
        .then(
          (rs) => {
            this.$bvToast.toast(`Successfully signed in as ${this.username}.`, {
              title: `Login`,
              variant: 'primary',
              solid: true
            })
            utilService.getListContact({
              q: 'q=',
              ordering: '',
              limit: '9999999999',
              offset: 0
            })
            router.push(this.returnUrl)
          },
          (error) => {
            this.error = error
            this.loading = false
          }
        )
    }
  }
}
</script>

<style lang="css" scoped>
.wrap-logo {
  box-shadow: 0px 0px 10px #ddd;
  position: relative;
  padding: 0;
  min-height: 495px;
}

.wrap-logo:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
}

.wrap-logo img {
  z-index: 99;
  position: relative;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  position: absolute;
  top: 15px;
}

.wrap-logo img.main-logo {
  position: absolute;
  width: 180px;
  left: calc(50% - 90px);
  top: calc(25% - 45px);
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue